import * as React from 'react';

import { Props } from './types';

const ArrowLeft = ({ className }: Props) => (
  <svg
    data-testid="arrow-left-icon"
    className={className}
    width="14"
    height="32"
    viewBox="0 0 14 32"
  >
    <path d="M13.6 6.3c0 .2-.1.4-.3.5L4.2 16l9.1 9.2a.7.7 0 010 1l-1.1 1.2a.7.7 0 01-1.1 0L.2 16.5 0 16c0-.2 0-.4.2-.5l10.9-11a.7.7 0 011 0l1.2 1.3a.7.7 0 01.3.5z" />
  </svg>
);

export default React.memo(ArrowLeft);
